document.addEventListener('DOMContentLoaded', () => {
	const requestBtns = document.querySelectorAll('.js-open-contact-form')

	if (document.querySelectorAll('.js-open-contact-form').length > 0){
		requestBtns.forEach(i => {
			i.addEventListener('click', () => {
				let fiooVariant = i.getAttribute('data-variant')
				document.querySelector('.js-fioo-variant').innerHTML = fiooVariant
				document.querySelector('#quote_request_fioo_variant').value = fiooVariant
				document.querySelector('.js-quote-request').classList.add('is-active')
				document.querySelector('body, html').classList.add('noscroll')
			})
		})


		const quoteForm = document.querySelector('#quote-request-form')

		quoteForm.addEventListener('submit', (e) => {
			e.preventDefault()
			dataToSend = {
				first_name: document.querySelector('#quote_request_first_name').value,
				last_name: document.querySelector('#quote_request_last_name').value,
				email: document.querySelector('#quote_request_email').value,
				tel: document.querySelector('#quote_request_tel').value,
				message: document.querySelector('#quote_request_message').value,
				variant: document.querySelector('#quote_request_fioo_variant').value,
			}

			document.querySelectorAll('.popup').forEach(i => i.classList.remove('is-active'))
			
			fetch('/quote-request', {
              method: 'post',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(dataToSend)
            }).then(res => {
              if (!res.ok) {
                throw new Error('Network response was not ok');
              }
              return res.json();
            }).then(data => {
              if (data.status === 'success') {
                  alert(data)
                document.querySelector('.js-quote-request-thanks').classList.add('is-active')
              }
            }).catch(error => {
              console.error('Errore:', error);
            });
		  

		})
	}
	
})